import styles from "./Assessments.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { MdOutlineTextSnippet } from "react-icons/md";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

const data = [
  {
    _id: "1",
    name: "John Jacsdklob",
    template: "Template 1",
    createdOn: "06/06/2025",
    actions: ["View Assessment"],
  },
  {
    _id: "2",
    name: "John Jasdjkdasfjkcob",
    template: "Template 1",
    createdOn: "06/06/2025",
    actions: ["View Assessment"],
  },
  {
    _id: "3",
    name: "John Jaadskldaskcob",
    template: "Template 1",
    createdOn: "06/06/2025",
    actions: ["View Assessment"],
  },
  {
    _id: "4",
    name: "John Jasdfkldsfklcob",
    template: "Template 1",
    createdOn: "06/06/2025",
    actions: ["View Assessment"],
  },
];
  

function Assessments() {
      const [selectedDate, setSelectedDate] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal("addFeePlan"));
  };
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        name: (
          <LogoWithName
            name={item.name}
            icon={item.name[0]}
            iconBgColor="#E4EEFF"
            iconColor="#3E7BFA"
          />
        ),
        template: item.template,
        createdOn: item.createdOn,
        viewAssessment: (
          <span
            className={styles.viewLink}
            onClick={() => console.log(`Viewing assessment for ${item.name}`)}
          >
            View Assessment
          </span>
        ),
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => console.log(`Selected ${opt} for ${item.name}`)}
          />
        ),
      };
    });
  };
  
  
  

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Name", accessor: "name" },
    { title: "Template Name", accessor: "template" },
    { title: "Created On", accessor: "createdOn" },
    { title: "", accessor: "viewAssessment" }, // No heading
    { title: "Action", accessor: "action" }, // Keep Action column
  ];
  
  

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}
        <div className={styles.createForm}>
          <IconAndName
            icon={<MdOutlineTextSnippet />}
            title="Create Assessment"
            bgColor="Primary_Color"
            onClick={handlecreateform}
          />
        </div>

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search  by student name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.filters}>
              <Dropdown
                label="Room"
                options={["Live", "Inactive", "Draft"]}
              />
              <Dropdown
                label="Template"
                options={["Live", "Inactive", "Draft"]}
              />
              <CalendarInput
                label="Date"
                value={selectedDate}
                onChange={setSelectedDate}
                background="var(--Utility_Color1)"
                textColor="gray"
                iconColor="gray"
                placeholderColor="gray"
                borderRadius="25px"
                shadow={false}
              />
              <Dropdown
                label="Status"
                options={["Live", "Inactive", "Draft"]}
              />
             
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Assessments;
